module.exports = __webpack_public_path__ + "img/bg_xiaozijiameng.37439995.svg";